import { Redirect, useParams, useLocation } from 'react-router-dom';
import { getJSON } from 'bv-fetch';
import { useFetch } from 'bv-hooks';
import { ContentLayout, Spinner } from 'bv-components';

const BetBuilderLauncher = () => {
  const { eventId, outcomeId } = useParams();
  const clickSource = new URLSearchParams(useLocation().search).get('clickSource');

  const [launchData, loading] = useFetch(
    () => getJSON(`/api/sportsbook/bet_builder2_launch_url?event_id=${eventId}${outcomeId ? `&outcome_id=${outcomeId}` : ''}&clickSource=${clickSource || ''}`),
    [eventId, clickSource],
  );

  if (loading) {
    return (
      <ContentLayout>
        <Spinner />
      </ContentLayout>
    );
  }

  return <Redirect to={launchData.url} />;
};

export default BetBuilderLauncher;
